import { OrderBookingMode, OrderType } from '@vista-digital/ocapi-types/v1';
import { isEmptyArray, isNonEmptyArray } from '../../../../utils/array-utils';
import { getOrderBookingMode } from '../../selectors/order/get-order-booking-mode';
import { getOrderUnpaidBalance } from '../../selectors/payments/get-order-unpaid-balance';
/**
 * Validates that an in-progress order is ready for completion.
 */
export const validateOrder = (order) => {
    switch (order.type) {
        case OrderType.Standard:
            return validateStandardOrder(order);
        case OrderType.GiftShop:
            return validateGiftShopOrder(order);
        case OrderType.Subscription:
            return validateSubscriptionOrder(order);
        default:
            throw new Error(`Cannot validate order with unknown OrderType: '${order.type}'.`);
    }
};
const validateStandardOrder = (order) => {
    const hasTickets = order.showtimes.some(showtime => isNonEmptyArray(showtime.tickets));
    if (!hasTickets && isEmptyArray(order.items)) {
        return { isValid: false, message: "Order doesn't contain any tickets or items." };
    }
    return validateUnpaidBalance(order);
};
const validateGiftShopOrder = (order) => {
    if (isEmptyArray(order.items)) {
        return { isValid: false, message: "Order doesn't contain any items." };
    }
    return validateUnpaidBalance(order);
};
const validateSubscriptionOrder = (order) => {
    if (!order.subscription) {
        return { isValid: false, message: "Order doesn't contain a subscription." };
    }
    return validateUnpaidBalance(order);
};
const validateUnpaidBalance = (order) => {
    const bookingMode = getOrderBookingMode();
    if (order.type === OrderType.Standard && bookingMode !== OrderBookingMode.Paid)
        return { isValid: true };
    const unpaidBalance = getOrderUnpaidBalance();
    return unpaidBalance === 0
        ? { isValid: true }
        : { isValid: false, message: `Order has an unpaid balance of ${unpaidBalance}.` };
};
